"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistingServiceCms = void 0;
var ExistingServiceCms = /** @class */ (function () {
    function ExistingServiceCms() {
        this.modelHeadingLabel = 'Existing service at your new location';
        this.modelDescriptionTxt = 'Avoid delays in getting your new service! What happens if the current '
            + 'occupants forget to disconnect service? By providing the landlord (or property manager) '
            + 'info below, we can step in and help.';
        this.modelButtonLabel = 'OK, I understand';
        this.submitButtonLabel = 'Submit info';
        this.cancelButtonLabel = 'Cancel';
        this.genericCTOHeadingLabel = 'Unable to complete order online';
        this.genericCTODescriptionOneTxt = 'Looks like you\'ll need to speak to one of our service reps to '
            + 'complete your order.';
        this.genericCTODescriptionTwoTxt = 'Please call us at <span class=\'phoneNumber\'>8xx.xxx.xxxx</span>.';
        this.ctoNum = "<span class='phoneNumber'>8xx.xxx.xxxx</span>";
        this.genericCTOExitCheckoutButtonLabel = 'Exit checkout';
    }
    return ExistingServiceCms;
}());
exports.ExistingServiceCms = ExistingServiceCms;
//# sourceMappingURL=existingservice.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/WorkServiceConflictCard/existingservice.cms.js
// module id = 1983
// module chunks = 8